.container {
  margin-bottom: 16px;
}

.optionRow {
  display: flex;
  flex: 1;
  gap: 16px;
}
